import * as React from "react";
import { DetailListActions, DropdownActionConfig } from "Components/General/DetailListActions";
import { withModal, WithModal } from "Components/General/Modal/withModal";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { TaskUploadFile } from "../Stores/TaskDataStore";
import { message } from "antd";

interface TaskFilesTableActionsProps extends WithTranslation, WithModal {
  files: Array<TaskUploadFile | API_FileDataEntity>;
  disabledDownload: boolean;
  onRemoveSelectedFiles: () => void;
  onDownload: () => void;
}
export type TaskFilesTableActionType = "download" | "remove";
export const TaskFilesTableActions = withModal(
  withTranslation(I18N_NS.PROJECT)(
    class extends React.Component<TaskFilesTableActionsProps> {
      handleMenuClick = async ({ key }: { key: TaskFilesTableActionType }) => {
        const { t, onDownload, files, onRemoveSelectedFiles } = this.props;
        if (!files.length) {
          message.error(t("No files were selected"));
        } else {
          let action: () => Promise<void>;
          switch (key) {
            case "download":
              action = () =>
                new Promise((res) => {
                  onDownload();
                  res();
                });
              break;
            case "remove":
              action = () =>
                new Promise((res) => {
                  onRemoveSelectedFiles();
                  res();
                });
              break;
            default:
              action = () => {
                message.warning(t("Invalid action"));
                return Promise.resolve();
              };
              break;
          }

          const hide = message.loading(t("Action in progress..."), 0);
          try {
            await action();
          } catch (error) {
            throw error;
          } finally {
            hide();
          }
        }
      };

      get dropdownActions(): DropdownActionConfig[] {
        const { t, disabledDownload } = this.props;
        const config = [
          {
            label: t("Download"),
            onClick: () => this.handleMenuClick({ key: "download" }),
            disabled: disabledDownload,
            icon: ["far", "download"] as IconProp,
          },
        ];

        if (this.props.onRemoveSelectedFiles !== null) {
          config.push({
            label: t("Remove"),
            onClick: () => this.handleMenuClick({ key: "remove" }),
            icon: ["far", "trash-alt"] as IconProp,
            disabled: false,
          });
        }

        return config;
      }
      render() {
        return <DetailListActions primaryActions={[]} dropdownActions={this.dropdownActions} />;
      }
    }
  )
);
